export default __webpack_public_path__ + "static/media/PK25.1c0e7f14.png";